import { render, staticRenderFns } from "./SupplyChainProvinceSupplierRanking.vue?vue&type=template&id=2ab1cbf3&scoped=true&"
import script from "./SupplyChainProvinceSupplierRanking.vue?vue&type=script&lang=js&"
export * from "./SupplyChainProvinceSupplierRanking.vue?vue&type=script&lang=js&"
import style0 from "./SupplyChainProvinceSupplierRanking.vue?vue&type=style&index=0&lang=less&"
import style1 from "./SupplyChainProvinceSupplierRanking.vue?vue&type=style&index=1&id=2ab1cbf3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab1cbf3",
  null
  
)

export default component.exports